import { useFactoryUserDashboardJob } from 'src/hooks/dashboard';
import { tryCall } from 'src/utils/core/functions';

export default () => {
  const { data: jobs, loading: jobsLoading } = tryCall(() => useFactoryUserDashboardJob(), { data: [], loading: false });
  
  return {
    jobs: (jobs && jobs.factoryUserDashboardJob) || [],
    jobsLoading
  };
};
